export enum ApiErrors {
    CONTRACT_ALREADY_MANAGED = "contractAlreadyManaged"
}
